module.exports = __webpack_public_path__ + "static/media/silkStream.b6329b18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/silkStream.jpg
// module id = 313
// module chunks = 0